import { useEffect, useMemo } from "react"
import { getKmlData } from "../../../redux/slices/hyperdrive/setting"
import { useDispatch } from "react-redux"
import mapboxgl from "mapbox-gl"
import 'mapbox-gl/dist/mapbox-gl.css'
import { useRef } from "react"
import { useSearchParams } from "react-router-dom"
import { useSelector } from "react-redux"

const KmlView = () => {
    const mapRef = useRef(null);
    const mapContainerRef = useRef(null);
    const [searchParams, setSearchParams] = useSearchParams();
    const fullRoleTablat = useMemo(() => searchParams.get('lat'), [searchParams]);
    const fullRoleTablng = useMemo(() => searchParams.get('lng'), [searchParams]);
    const fullRoleTabzomm = useMemo(() => searchParams.get('zoom'), [searchParams]);
    const INITIAL_CENTER = [fullRoleTablng ? fullRoleTablng : -118.2426, fullRoleTablat ? fullRoleTablat : 34.0549];
    const INITIAL_ZOOM = fullRoleTabzomm ? fullRoleTabzomm : 9.5;
    const { getKmlDataCoordinate } = useSelector(state => state.commonHyperdrive);

    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getKmlData())
    }, [])

    // Initialize the map
    useEffect(() => {
        if (!mapContainerRef.current) return;

        const map = new mapboxgl.Map({
            container: mapContainerRef.current,
            style: 'mapbox://styles/mapbox/streets-v12',
            center: INITIAL_CENTER,
            zoom: INITIAL_ZOOM,
            // --------------------2D----------------------
            pitchWithRotate: false,      // Disable pitch with rotation
            dragRotate: false,           // Disable rotation by dragging
            touchZoomRotate: false,      // Disable rotation on touch devices
            maxPitch: 0,                 // Set maximum pitch to 0 (completely flat)
            projection: 'mercator'       // Use standard 2D projection
        });

        mapRef.current = map;

        // Add navigation controls
        map.addControl(new mapboxgl.NavigationControl(), 'top-right');

        return () => {
            if (mapRef.current) {
                mapRef.current.remove();
                mapRef.current = null;
            }
        };
    }, []);

    // useEffect(() => {
    //     if (!mapRef.current || !getKmlDataCoordinate?.activeTerminals?.length) return;

    //     const map = mapRef.current;

    //     // Wait for the style to be loaded
    //     const waitForStyleLoad = () => {
    //         if (!map.isStyleLoaded()) {
    //             setTimeout(waitForStyleLoad, 100);
    //             return;
    //         }

    //         const geojson = {
    //             type: 'FeatureCollection',
    //             features: getKmlDataCoordinate.activeTerminals.map((terminal, index) => ({
    //                 type: 'Feature',
    //                 id: `terminal-${index}`,
    //                 properties: {
    //                     color: '#FF0000',
    //                     opacity: 0.5
    //                 },
    //                 geometry: {
    //                     type: 'Polygon',
    //                     coordinates: [
    //                         terminal.coordinates.map(coord => [coord.lng, coord.lat])
    //                     ]
    //                 }
    //             }))
    //         };

    //         // Clean up existing layers and sources
    //         if (map.getLayer('dynamic-layer')) map.removeLayer('dynamic-layer');
    //         if (map.getLayer('dynamic-layer-outline')) map.removeLayer('dynamic-layer-outline');
    //         if (map.getSource('dynamic-source')) map.removeSource('dynamic-source');

    //         // Add the source
    //         map.addSource('dynamic-source', {
    //             type: 'geojson',
    //             data: geojson
    //         });

    //         // Add fill layer with yellow color
    //         map.addLayer({
    //             id: 'dynamic-layer',
    //             type: 'fill',
    //             source: 'dynamic-source',
    //             paint: {
    //                 'fill-color': '#696969',  // Yellow fill
    //                 'fill-opacity': 0.35,
    //                 'fill-outline-color': '#0000FF'  // Blue outline
    //             }
    //         });

    //         // Add outline layer with blue color
    //         map.addLayer({
    //             id: 'dynamic-layer-outline',
    //             type: 'line',
    //             source: 'dynamic-source',
    //             paint: {
    //                 'line-color': '#0000FF',  // Blue outline
    //                 'line-width': 2
    //             }
    //         });

    //         // Fit bounds
    //         const bounds = new mapboxgl.LngLatBounds();
    //         geojson.features.forEach(feature => {
    //             if (feature.geometry.type === 'Polygon') {
    //                 feature.geometry.coordinates[0].forEach(coord => {
    //                     bounds.extend(coord);
    //                 });
    //             }
    //         });

    //         if (!bounds.isEmpty()) {
    //             map.fitBounds(bounds, { padding: 50, duration: 0 }); // Add duration: 0 for instant fit
    //         }
    //     };

    //     // Start the loading check
    //     waitForStyleLoad();

    //     // Cleanup function
    //     return () => {
    //         if (mapRef.current) {
    //             const m = mapRef.current;
    //             if (m.getLayer('dynamic-layer')) m.removeLayer('dynamic-layer');
    //             if (m.getLayer('dynamic-layer-outline')) m.removeLayer('dynamic-layer-outline');
    //             if (m.getSource('dynamic-source')) m.removeSource('dynamic-source');
    //         }
    //     };
    // }, [getKmlDataCoordinate]);
    const popupRef = useRef(null);

    useEffect(() => {
        if (!mapRef.current || !getKmlDataCoordinate?.activeTerminals?.length) return;

        const map = mapRef.current;
    
        const waitForStyleLoad = () => {
            if (!map.isStyleLoaded()) {
                setTimeout(waitForStyleLoad, 100);
                return;
            }

            const geojson = {
                type: 'FeatureCollection',
                features: getKmlDataCoordinate.activeTerminals.map((terminal, index) => ({
                    type: 'Feature',
                    id: `terminal-${index}`,
                    properties: {
                        color: '#FF0000',
                        opacity: 0.5,
                        regionName: terminal.regionName || 'No Region assigned', // Make sure regionName is included
                        driverName: terminal.driverName || 'No Driver assigned' // Make sure regionName is included

                    },
                    geometry: {
                        type: 'Polygon',
                        coordinates: [
                            terminal.coordinates.map(coord => [coord.lng, coord.lat])
                        ]
                    }
                }))
            };

            // Clean up existing layers and sources
            if (map.getLayer('dynamic-layer')) map.removeLayer('dynamic-layer');
            if (map.getLayer('dynamic-layer-outline')) map.removeLayer('dynamic-layer-outline');
            if (map.getSource('dynamic-source')) map.removeSource('dynamic-source');

            // Add the source
            map.addSource('dynamic-source', {
                type: 'geojson',
                data: geojson
            });

            // Add fill layer with yellow color
            map.addLayer({
                id: 'dynamic-layer',
                type: 'fill',
                source: 'dynamic-source',
                paint: {
                    'fill-color': '#696969',
                    'fill-opacity': 0.35,
                    'fill-outline-color': '#0000FF'
                }
            });

            // Add outline layer with blue color
            map.addLayer({
                id: 'dynamic-layer-outline',
                type: 'line',
                source: 'dynamic-source',
                paint: {
                    'line-color': '#0000FF',
                    'line-width': 2
                }
            });

            // Add click event for the fill layer
            map.on('click', 'dynamic-layer', (e) => {
                if (e.features.length > 0) {
                    const feature = e.features[0];
                    const coordinates = e.lngLat;
                    const regionName = feature.properties.regionName;
                    const driverName = feature.properties.driverName;
                    // Close any existing popup
                    // Remove existing popup
                    if (popupRef.current) {
                        popupRef.current.remove();
                    }

                    // Create a new popup
                    popupRef.current = new mapboxgl.Popup({
                        closeButton: true,
                        closeOnClick: true
                    }).setLngLat(coordinates)
                        .setHTML(`<ul class="tooltip-modal">
                            <li>
                                <span>Region Name: </span>
                                <p>${regionName}</p>
                            </li>
                            <li>
                                <span>Driver Name: </span>
                                <p>${driverName}</p>
                            </li>
                        </ul>`)
                        .addTo(map);
                }
            });

            // Change the cursor to a pointer when hovering over the layer
            map.on('mouseenter', 'dynamic-layer', () => {
                map.getCanvas().style.cursor = 'pointer';
            });

            // Change it back to default when leaving
            map.on('mouseleave', 'dynamic-layer', () => {
                map.getCanvas().style.cursor = '';
            });

            // Fit bounds
            const bounds = new mapboxgl.LngLatBounds();
            geojson.features.forEach(feature => {
                if (feature.geometry.type === 'Polygon') {
                    feature.geometry.coordinates[0].forEach(coord => {
                        bounds.extend(coord);
                    });
                }
            });

            if (!bounds.isEmpty()) {
                map.fitBounds(bounds, { padding: 50, duration: 0 });
            }
        };

        // Start the loading check
        waitForStyleLoad();

        // Cleanup function
        return () => {
            if (mapRef.current) {
                const m = mapRef.current;
                if (m.getLayer('dynamic-layer')) m.removeLayer('dynamic-layer');
                if (m.getLayer('dynamic-layer-outline')) m.removeLayer('dynamic-layer-outline');
                if (m.getSource('dynamic-source')) m.removeSource('dynamic-source');
                m.off('click', 'dynamic-layer');
                m.off('mouseenter', 'dynamic-layer');
                m.off('mouseleave', 'dynamic-layer');
                if (popupRef.current) {
                    popupRef.current.remove();
                    popupRef.current = null;
                }
            }
        };
    }, [getKmlDataCoordinate]);

    return (
        // <div className='hd-left-wrapper'>

        <div
            ref={mapContainerRef}
            style={{
                width: '100%',
                height: '100%',
                backgroundColor: '#0F0F13',
                paddingLeft: '16px',
                paddingBottom: '16px'
            }}
            className="tooltip-container-modal"
        />
        // </div>
    )
}
export default KmlView